<template>
  <div class="loading">
    <div class="cube-popup cube-popup_mask cube-toast" style="z-index: 900;">
      <div class="cube-popup-mask"></div>
      <div class="cube-popup-container cube-popup-center">
        <div class="cube-popup-content">
          <div class="cube-toast-tip">加载中...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>

<style lang="less" scoped>
.loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 1;
  .cube-toast.cube-popup {
    z-index: 900
  }
  .cube-toast .cube-popup-content {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    padding: .13rem .16rem;
    color: #ccc;
    background-color: rgba(37,38,45,.9);
    border-radius: .1rem;
    margin: 0 auto;
  }

  .cube-toast-icon {
    width: .24rem;
    height: .24rem;
    font-size: .24rem
  }

  .cube-popup-center {
    top: 0;
    left: 0;
    -webkit-transform: translate(0);
    transform: translate(0);
    display: flex;
    display: -webkit-flex;
    align-items: center;
  }


  .cube-toast-tip {
    line-height: .2rem;
    font-size: .14rem;
    overflow: hidden
  }

  .cube-loading~.cube-toast-tip,.cube-toast-icon~.cube-toast-tip {
    margin-left: .08rem
  }

  .cube-toast-fade-enter-active {
    -webkit-animation: toast-in .2s;
    animation: toast-in .2s
  }

  .cube-toast-fade-leave-active {
    -webkit-animation: toast-out .2s;
    animation: toast-out .2s
  }
  .cube-popup_mask {
    pointer-events: auto;
  }
  .cube-popup_mask .cube-popup-mask {
    display: block;
    top: 0;
    left: 0;
  }
  .cube-popup-container,.cube-popup-mask {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .cube-popup-mask {
    display: none;
    overflow: hidden;
    background-color: #25262d;
    opacity: .4;
    pointer-events: auto
  }
  .cube-popup-mask:before {
    content: ".";
    display: block;
    width: .01rem;
    height: .01rem;
    background-color: rgba(0,0,0,.1);
    margin-left: -.1rem
  }

  @-webkit-keyframes toast-in {
    0% {
      opacity: 0
    }

    to {
      opacity: 1
    }
  }

  @keyframes toast-in {
    0% {
      opacity: 0
    }

    to {
      opacity: 1
    }
  }

  @-webkit-keyframes toast-out {
    0% {
      opacity: 1
    }

    to {
      opacity: 0
    }
  }

  @keyframes toast-out {
    0% {
      opacity: 1
    }

    to {
      opacity: 0
    }
  }
}
</style>
